import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { WebApiService } from '../service/web-api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class SignUpService {

  constructor(private webApiServece: WebApiService) { }

  /**
   * メールアドレスに認証URL付きメール送信
   * @param mailAddress メールアドレス
   * @param screenId 画面ID
   * @param pageNo 次ページ番号
   * @param nextParameter 認証URLから遷移する先のページに引き継ぐ情報（JSON形式）
   */
  execAuthSendMail(mailAddress: string, screenId: string, pageNo: number, nextParameter: string): Observable<any[]> {
    const requestParam = {
      'mail_address': mailAddress,
      'check': 'duplicate',
      'screen_id': screenId,
      'page_no': pageNo,
      'next_parameter': nextParameter
    };
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/auth-send-mail', requestParam)
      .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (!data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }

  /**
   * メール認証チェック
   */
  execAuthCheckMail(): Observable<any[]> {
    const requestParam = {};
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/auth-check-mail', requestParam)
      .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (!data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }

  /**
   * アカウント作成
   * @param userId ユーザ名
   * @param password パスワード
   * @param confirmPassword 確認用パスワード
   * @param mailAddress メールアドレス
   * @param consentCheck 利用規約同意チェック
   * @param birthdate 生年月日
   * @param familyName カナ姓
   * @param givenName カナ名
   * @param phoneNumber 電話番号
   */
  execAuthRegisterAccount(userId: string, password: string, confirmPassword: string,
    mailAddress: string, consentCheck: boolean, birthdate: string, familyName: string,
    givenName: string, phoneNumber: string): Observable<any[]> {
    const requestParam = {
      'user_id': userId, 'password': password, 'confirm_password': confirmPassword,
      'mail_address': mailAddress, 'consent_check': consentCheck, 'birthdate': birthdate,
      'family_name': familyName, 'given_name': givenName, 'phone_number': phoneNumber
    };
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/auth-register-account', requestParam)
      .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (!data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }
}
